import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { TypeUtility } from 'utility-ts-type';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { APTermsQuery } from '../../../plan/queries/ap_terms_query';
import { AdvisorHeaderDetailsQuery } from '../../../suggestions/components/plan_feedback/queries/advisor_plan_details_query';
import { APAdvisorSentFeedbackTermsQuery } from '../../../suggestions/components/plan_feedback/queries/advisor_sent_feedback_terms_query';
import { PlanFeedbackServant } from '../../../suggestions/components/plan_feedback/servants/plan_feedback_servant';
import { APModel, IAPProgram } from '../../models/ap_model';
class StudentPlanProgress {
  private queries: { feedback: APAdvisorSentFeedbackTermsQuery };
  private models: {
    program: IAPProgram;
  };
  private programTitle: string;
  private creditsTitle: string;
  private studentName: string;
  private showCompletedPopup: boolean;
  private currentPlan: any;
  constructor(
    private ngAPStudentDetailsQuery: IQuery,
    private ngAPTermsQuery: APTermsQuery,
    private ngAPAdvisorSentFeedbackTermsQuery: APAdvisorSentFeedbackTermsQuery,
    private ngAPModel: APModel,
    private ngAPNotificationDelegate: INotificationDelegate,
    private loadPlanFeedbackCommand: ICommand,
    private navigateIfPlanBlockedCommand: ICommand,
    private $element: ng.IAugmentedJQuery,
    private $state: ng.ui.IStateService,
    private ngAPAdvisorHeaderDetailsQuery: AdvisorHeaderDetailsQuery
  ) {
    this.queries = {
      feedback: this.ngAPAdvisorSentFeedbackTermsQuery
    };
    this.models = {
      program: _4.head(_4.toArray(this.ngAPModel.read().program))
    };
  }

  $onInit() {
    this.currentPlan = [...this.ngAPAdvisorSentFeedbackTermsQuery.result.termsAndGenericSlots];
    this.studentName = this.ngAPStudentDetailsQuery.result.first_name;
    this.programTitle = `${this.models.program.name} ${this.models.program.short_credential}`;
    this.creditsTitle = `| ${TypeUtility.NumberUtility.stripTrailingZeroes(this.models.program.credits)} Credit(s)`;
    this.showCompletedPopup = PlanFeedbackServant.isPlanReadOnlyMode(this.ngAPAdvisorHeaderDetailsQuery.result);
  }

  loadUpdatesFromStudent() {
    this.navigateIfPlanBlockedCommand().then(() => {
      this.showCompletedPopup = PlanFeedbackServant.isPlanReadOnlyMode(this.ngAPAdvisorHeaderDetailsQuery.result);
      if (this.showCompletedPopup) {
        return;
      }
      this.loadPlanFeedbackCommand().then(() => {
        const defaultTimeout = 4000;
        if (!angular.equals(this.currentPlan, this.ngAPAdvisorSentFeedbackTermsQuery.result.termsAndGenericSlots)) {
          this.currentPlan = [...this.ngAPAdvisorSentFeedbackTermsQuery.result.termsAndGenericSlots];
          this.ngAPNotificationDelegate.success({
            content: `Updated student's plan`,
            timeout: defaultTimeout
          });
        } else {
          this.ngAPNotificationDelegate.info({
            content: `No changes to the plan`,
            timeout: defaultTimeout
          });
        }
      });
    });
  }

  viewHistory() {
    this.$state.go('ap-advisor.changelog');
  }

  closeModal() {
    this.$state.go('ap-advisor.plan', { reload: true });
  }

  popupOpenStatusChanged($event: any) {
    if (!$event.detail.value) {
      this.closeModal();
    }
  }
}

angular.module('capability-ng-academic-planner').component('studentPlanProgress', {
  templateUrl: 'capability-ng-academic-planner/src/global/components/student_plan_progress/student_plan_progress.html',
  controller: StudentPlanProgress
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/student_plan_progress/student_plan_progress.ts